import { NavigationContext } from 'expo-router/react-navigation';
import { type RefObject, use, useEffect } from 'react';
import { Keyboard } from 'react-native';
import { scheduleAutoFocusAfterTransition } from './autoFocusAfterTransition';

type FocusTarget = {
  focus(): void;
};

function waitForKeyboardIdle(listener: () => void) {
  if (!Keyboard.isVisible()) {
    listener();
    return () => {};
  }

  const subscription = Keyboard.addListener('keyboardDidHide', listener);
  return () => subscription.remove();
}

export default function useAutoFocusAfterTransition<Target extends FocusTarget>(
  ref: RefObject<Target | null>,
  autoFocus: boolean | undefined,
) {
  const navigation = use(NavigationContext);

  useEffect(() => {
    if (!autoFocus) {
      return;
    }

    if (process.env.EXPO_OS === 'web') {
      return scheduleAutoFocusAfterTransition(ref, null);
    }

    return scheduleAutoFocusAfterTransition(
      ref,
      navigation,
      waitForKeyboardIdle,
    );
  }, [autoFocus, navigation, ref]);
}
